/* Seyasha offers
   - Product page: shows the coupons that work on this product, the price after each one, and a Copy button.
   - Cart drawer and cart page: one panel right above the Checkout button with
       the code that is applied (and what it saves),
       a "better offer" nudge when another code saves more,
       an "add ₹X more" progress bar when a bigger saving is close, and
       the other offers that fit this bag.
   Coupons come from Content > Metaobjects > Seyasha coupon (rendered into #sy-coupons).
   All money values are in paise. */
(function () {
  if (window.__syOffers) return;
  window.__syOffers = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var COUPONS = [], COLS = {}, FMT = '₹{{amount_no_decimals}}';
  function load(text) {
    var d = {};
    try { d = JSON.parse(text || '{}'); } catch (e) { return false; }
    var list = Array.isArray(d) ? d : (d.coupons || []);
    COUPONS = list.filter(function (c) { return c && c.code && c.value > 0; }).map(function (c) {
      c.code = String(c.code).toUpperCase();
      c.ids = (c.ids || []).map(String);
      c.cols = (c.cols || []).map(String);
      c.min = Math.max(0, Math.round(c.min || 0));
      return c;
    });
    if (d.fmt) FMT = String(d.fmt).replace(/<[^>]*>/g, '');
    var m = d.cart || {};
    Object.keys(m).forEach(function (k) { COLS[k] = (m[k] || []).map(String); });
    return true;
  }
  var src = document.getElementById('sy-coupons');
  if (src) load(src.textContent);

  /* ---------- maths (also exported for tests) ---------- */
  function fits(c, productId) {
    var pid = String(productId);
    if (c.all || c.ids.indexOf(pid) > -1) return true;
    var mine = COLS[pid] || [];
    for (var i = 0; i < c.cols.length; i++) if (mine.indexOf(c.cols[i]) > -1) return true;
    return false;
  }
  function eligibleTotal(c, items) {
    var t = 0;
    (items || []).forEach(function (i) { if (fits(c, i.product_id)) t += i.original_line_price != null ? i.original_line_price : i.price * i.quantity; });
    return t;
  }
  function saving(c, eligible) {
    if (eligible <= 0) return 0;
    if (c.type === 'flat') return Math.min(Math.round(c.value * 100), eligible);
    return Math.round(eligible * c.value / 100);
  }
  /* state of one coupon against a list of cart-like items: {eligible, unlocked, short, save, saveAtMin} */
  function evaluate(c, items) {
    var el = eligibleTotal(c, items);
    var unlocked = el > 0 && el >= c.min;
    return {
      c: c,
      eligible: el,
      unlocked: unlocked,
      short: unlocked ? 0 : Math.max(0, c.min - el),
      save: unlocked ? saving(c, el) : 0,
      saveAtMin: saving(c, Math.max(el, c.min))
    };
  }
  /* what the cart panel should say */
  function plan(cart) {
    var items = cart.items || [];
    var applied = (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return String(d.code).toUpperCase(); })[0] || null;
    var invalid = (cart.discount_codes || []).filter(function (d) { return !d.applicable; }).map(function (d) { return String(d.code).toUpperCase(); })[0] || null;
    var current = applied ? (cart.total_discount || 0) : 0;
    /* only offers that touch something in this bag */
    var rows = COUPONS.map(function (c) { return evaluate(c, items); }).filter(function (r) { return r.c.all || r.eligible > 0; });
    var open = rows.filter(function (r) { return r.unlocked; }).sort(function (a, b) { return b.save - a.save; });
    var best = open[0] || null;
    var better = best && best.c.code !== applied && best.save > current + 100 ? best : null; /* at least ₹1 more */
    var top = Math.max(current, best ? best.save : 0);
    /* the closest locked offer that would beat today's best saving */
    var next = rows.filter(function (r) { return !r.unlocked && r.saveAtMin > top; })
      .sort(function (a, b) { return a.short - b.short || b.saveAtMin - a.saveAtMin; })[0] || null;
    return { applied: applied, invalid: invalid, current: current, rows: rows, best: best, better: better, next: next };
  }

  function money(paise) {
    var r = paise / 100;
    var whole = Math.abs(r - Math.round(r)) < 0.005;
    var n = r.toLocaleString('en-IN', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 });
    return /\{\{\s*\w+\s*\}\}/.test(FMT) ? FMT.replace(/\{\{\s*\w+\s*\}\}/, n) : '₹' + n;
  }
  function offText(c) { return c.type === 'flat' ? money(Math.round(c.value * 100)) + ' off' : (+c.value) + '% off'; }
  function ruleText(c) {
    var t = offText(c);
    if (c.min > 0) t += ' on ' + (c.all ? 'orders' : 'these styles') + ' above ' + money(c.min);
    else if (!c.all) t += ' on select styles';
    return t;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }

  window.SyOffers = { evaluate: evaluate, plan: plan, saving: saving, money: money, ruleText: ruleText, _set: function (list, cols) { COUPONS = list.map(function (c) { c.cols = c.cols || []; c.ids = c.ids || []; return c; }); COLS = cols || {}; } };
  if (typeof document === 'undefined' || !document.addEventListener) return;

  /* ---------- shared helpers ---------- */
  var realFetch = window.fetch.bind(window);
  var cartCache = null;
  function getCart() {
    return realFetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { cartCache = c; return c; });
  }
  function copy(text) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
    return new Promise(function (res) {
      var t = document.createElement('textarea');
      t.value = text; t.setAttribute('readonly', ''); t.style.cssText = 'position:fixed;opacity:0;left:-9999px';
      document.body.appendChild(t); t.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(t); res();
    });
  }
  function scissors() {
    return '<svg class="sy-off__ic" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8Z"/><circle cx="7.5" cy="7.5" r="1.5" fill="currentColor"/></svg>';
  }

  /* ---------- product page ---------- */
  function pdpRender(box, cart) {
    box.__done = true;
    var pid = box.getAttribute('data-product-id');
    var price = parseInt(box.getAttribute('data-price'), 10) || 0;
    if (!pid || !price) { box.hidden = true; return; }
    var own = box.getAttribute('data-cols');
    if (own != null && !COLS[String(pid)]) COLS[String(pid)] = own.split(',').filter(Boolean);
    var inBag = (cart && cart.items) ? cart.items.filter(function (i) { return String(i.product_id) !== String(pid); }) : [];
    var thisItem = { product_id: pid, original_line_price: price, quantity: 1 };
    var rows = COUPONS.filter(function (c) { return fits(c, pid); }).map(function (c) {
      var r = evaluate(c, inBag.concat([thisItem]));
      /* price of one piece with the code on */
      r.after = Math.max(0, price - (c.type === 'flat' ? Math.min(Math.round(c.value * 100), price) : Math.round(price * c.value / 100)));
      return r;
    });
    if (!rows.length) { box.hidden = true; box.innerHTML = ''; effRender(null, price); return; }
    rows.sort(function (a, b) {
      if (a.unlocked !== b.unlocked) return a.unlocked ? -1 : 1;
      return a.unlocked ? a.after - b.after : a.short - b.short || a.after - b.after;
    });
    /* the effective price is what one piece costs on its own with the best code, same as on the cards */
    var solo = bestSolo(pid, price);
    effRender(solo ? { c: solo.c, after: price - solo.s } : null, price);
    var html = '<p class="sy-off__label">' + scissors() + '<span>Offers for you</span>' + (rows.length > 1 ? '<em>' + rows.length + ' codes · use any one</em>' : '') + '</p>';
    rows.forEach(function (r, n) {
      var c = r.c, lead = n === 0;
      var line = r.unlocked
        ? (lead ? 'Get it for <b>' + money(r.after) + '</b>' : 'Price with code <b>' + money(r.after) + '</b>')
        : 'Add <b>' + money(r.short) + '</b> more to your bag' + (c.type === 'pct' ? ' · then <b>' + money(r.after) + '</b>' : '');
      html += '<div class="sy-off__ticket' + (lead ? ' is-lead' : '') + (r.unlocked ? '' : ' is-locked') + '"' + (n > 0 ? ' data-more' : '') + '>' +
        '<div class="sy-off__main">' +
          (lead && r.unlocked ? '<span class="sy-off__tag">Best price</span>' : '') +
          '<p class="sy-off__price">' + line + '</p>' +
          '<p class="sy-off__rule">' + esc(c.headline || ruleText(c)) + '</p>' +
        '</div>' +
        '<div class="sy-off__stub">' +
          '<span class="sy-off__code">' + esc(c.code) + '</span>' +
          '<button type="button" class="sy-off__copy" data-code="' + esc(c.code) + '" aria-label="Copy code ' + esc(c.code) + '">Copy</button>' +
        '</div>' +
      '</div>';
    });
    if (rows.length > 1) html += '<button type="button" class="sy-off__more" aria-expanded="false">+' + (rows.length - 1) + ' more offer' + (rows.length > 2 ? 's' : '') + '</button>';
    html += '<p class="sy-off__note">Apply the code in your bag or at checkout. One code per order.</p>';
    html += suLine('sy-off__su');
    box.innerHTML = html;
    box.hidden = false;
    if (box.__open) box.classList.add('is-open');
  }
  function pdpAll(cart) { document.querySelectorAll('[data-sy-offers-pdp]').forEach(function (b) { pdpRender(b, cart); }); }

  /* the effective price, right under the product price */
  function effRender(lead, price) {
    document.querySelectorAll('[data-sy-eff-pdp]').forEach(function (el) {
      if (!lead) { el.hidden = true; el.innerHTML = ''; return; }
      var save = price - lead.after;
      el.innerHTML = '<div class="sy-eff__l"><span class="sy-eff__tag">Effective price</span>' +
        '<span class="sy-eff__p">' + money(lead.after) + '</span>' +
        '<span class="sy-eff__how">with code <b class="sy-eff__code">' + esc(lead.c.code) + '</b>' + (save > 0 ? ' · <span class="sy-eff__save">you save ' + money(save) + '</span>' : '') + '</span></div>' +
        '<button type="button" class="sy-eff__btn sy-off__copy" data-code="' + esc(lead.c.code) + '" data-label="Copy code" aria-label="Copy code ' + esc(lead.c.code) + '">Copy code</button>';
      el.hidden = false;
    });
  }

  /* product cards: the best price one piece gets on its own with a code */
  function bestSolo(pid, price) {
    var best = null;
    COUPONS.forEach(function (c) {
      if (!fits(c, pid) || c.min > price) return;
      var s = saving(c, price);
      if (s > 0 && (!best || s > best.s)) best = { c: c, s: s };
    });
    return best;
  }
  function cardsRender(root) {
    if (!COUPONS.length) return;
    (root || document).querySelectorAll('[data-sy-card][data-sy-pr]').forEach(function (card) {
      var slot = card.querySelector('[data-sy-eff]');
      if (!slot || slot.__sy) return;
      slot.__sy = true;
      var pid = card.getAttribute('data-sy-id'), price = parseInt(card.getAttribute('data-sy-pr'), 10) || 0;
      if (!pid || !price) return;
      var cols = card.getAttribute('data-sy-cols');
      if (cols != null && !COLS[String(pid)]) COLS[String(pid)] = cols.split(',').filter(Boolean);
      var b = bestSolo(pid, price);
      if (!b) return;
      slot.innerHTML = '<b>' + money(price - b.s) + '</b><span>with ' + esc(b.c.code) + '</span>';
      slot.hidden = false;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.sy-off__copy');
    if (btn) {
      e.preventDefault();
      var code = btn.getAttribute('data-code');
      copy(code).then(function () {
        btn.textContent = 'Copied';
        btn.classList.add('is-done');
        clearTimeout(btn._t);
        btn._t = setTimeout(function () { btn.textContent = btn.getAttribute('data-label') || 'Copy'; btn.classList.remove('is-done'); }, 2000);
      });
      return;
    }
    var more = e.target.closest && e.target.closest('.sy-off__more');
    if (more) {
      var box = more.closest('[data-sy-offers-pdp]');
      var open = !box.classList.contains('is-open');
      box.classList.toggle('is-open', open);
      box.__open = open;
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
      more.textContent = open ? 'Show less' : '+' + (box.querySelectorAll('[data-more]').length) + ' more offer' + (box.querySelectorAll('[data-more]').length > 1 ? 's' : '');
      return;
    }
    var act = e.target.closest && e.target.closest('[data-sy-act]');
    if (act) { e.preventDefault(); cartAction(act); }
  });

  /* ---------- cart panel ---------- */
  var busy = false, flash = null;
  function panelHTML(cart) {
    if (!cart || !cart.items || !cart.items.length) return '';
    var p = plan(cart);
    if (!p.rows.length && !p.applied && !p.invalid) return '';
    var h = '';
    /* 1. state of the code */
    if (p.applied) {
      h += '<div class="sy-cp__state is-on">' + scissors() +
        '<p><b>' + esc(p.applied) + '</b> applied · you save <b>' + money(p.current) + '</b></p>' +
        '<button type="button" class="sy-cp__link" data-sy-act="remove">Remove</button></div>';
    } else if (p.invalid) {
      h += '<div class="sy-cp__state is-bad">' +
        '<p><b>' + esc(p.invalid) + '</b> doesn’t work on this bag yet</p>' +
        '<button type="button" class="sy-cp__link" data-sy-act="remove">Remove</button></div>';
    }
    /* 2. better offer / best offer */
    if (p.better) {
      var extra = p.better.save - p.current;
      h += '<div class="sy-cp__nudge">' +
        '<p><span class="sy-cp__tag">' + (p.applied ? 'Better offer' : 'Best offer for you') + '</span>' +
        '<b>' + esc(p.better.c.code) + '</b> saves <b>' + money(p.better.save) + '</b>' + (p.applied ? ' (' + money(extra) + ' more)' : '') + '</p>' +
        '<button type="button" class="sy-cp__btn" data-sy-act="apply" data-code="' + esc(p.better.c.code) + '">' + (p.applied ? 'Switch' : 'Apply') + '</button></div>';
    }
    /* 3. progress bar to the next bigger saving */
    if (p.next) {
      var pct = Math.max(4, Math.min(100, Math.round(p.next.eligible / p.next.c.min * 100)));
      h += '<div class="sy-cp__bar">' +
        '<p>Add <b>' + money(p.next.short) + '</b> more' + (p.next.c.all ? '' : ' of eligible styles') + ' to save <b>' + money(p.next.saveAtMin) + '</b> with <b>' + esc(p.next.c.code) + '</b></p>' +
        '<div class="sy-cp__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><i style="width:' + pct + '%"></i></div></div>';
    }
    /* 4. the rest, folded */
    var shown = {};
    if (p.applied) shown[p.applied] = 1;
    if (p.better) shown[p.better.c.code] = 1;
    var rest = p.rows.filter(function (r) { return !shown[r.c.code]; }).sort(function (a, b) {
      if (a.unlocked !== b.unlocked) return a.unlocked ? -1 : 1;
      return a.unlocked ? b.save - a.save : a.short - b.short;
    });
    if (rest.length) {
      h += '<details class="sy-cp__list"' + (window.__syCpOpen ? ' open' : '') + '><summary>' + (shown[p.applied] || p.better ? 'Other offers' : 'Offers for this bag') + ' (' + rest.length + ')</summary><ul>';
      rest.forEach(function (r) {
        var right = r.c.code === p.applied ? '<span class="sy-cp__muted">Applied</span>'
          : r.unlocked ? '<button type="button" class="sy-cp__link" data-sy-act="apply" data-code="' + esc(r.c.code) + '">Apply</button>'
          : '<span class="sy-cp__muted">Add ' + money(r.short) + '</span>';
        h += '<li><div><b>' + esc(r.c.code) + '</b><span>' + esc(r.c.headline || ruleText(r.c)) + (r.unlocked ? ' · saves ' + money(r.save) : '') + '</span></div>' + right + '</li>';
      });
      h += '</ul></details>';
    }
    if (flash) h += '<p class="sy-cp__flash" role="status">' + esc(flash) + '</p>';
    if (h) h += suLine('sy-cp__su');
    return h ? '<div class="sy-cp__in">' + h + '</div>' : '';
  }
  /* signed-out visitors: one line that opens the sign-up pop-up (sections/sy-signup.liquid) */
  function suLine(cls) {
    var el = document.getElementById('sy-su-cfg'), t = '';
    if (!el || !document.querySelector('[data-sy-su]')) return '';
    try { t = (JSON.parse(el.textContent || '{}').teaser) || ''; } catch (e) { return ''; }
    return t ? '<button type="button" class="' + cls + '" data-sy-su-open>' + esc(t) + '</button>' : '';
  }
  function panels() {
    var out = [];
    document.querySelectorAll('.cart__ctas').forEach(function (ctas) {
      var prev = ctas.previousElementSibling;
      if (!prev || !prev.classList.contains('sy-cp')) {
        prev = document.createElement('div');
        prev.className = 'sy-cp';
        prev.setAttribute('aria-live', 'polite');
        ctas.parentNode.insertBefore(prev, ctas);
      }
      out.push(prev);
    });
    return out;
  }
  function paint(cart) {
    var html = panelHTML(cart);
    panels().forEach(function (el) {
      if (el.__html !== html) { el.innerHTML = html; el.__html = html; }
      el.hidden = !html;
    });
  }
  function refresh() {
    if (!COUPONS.length) return Promise.resolve();
    return getCart().then(function (cart) {
      var needCols = COUPONS.some(function (c) { return c.cols.length; }) &&
        (cart.items || []).some(function (i) { return !COLS[String(i.product_id)]; });
      if (!needCols) return cart;
      return realFetch(ROOT + '?sections=sy-offers-data', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var html = j && j['sy-offers-data'];
          var m = html && html.match(/<script[^>]*id="sy-coupons"[^>]*>([\s\S]*?)<\/script>/);
          if (m) load(m[1]);
          return cart;
        }).catch(function () { return cart; });
    }).then(function (cart) { paint(cart); pdpAll(cart); }).catch(function () {});
  }
  function redrawTheme() {
    var drawerItems = document.querySelector('cart-drawer-items');
    var onCartPage = /\/cart\/?$/.test(location.pathname);
    if (onCartPage) { location.reload(); return Promise.resolve(); }
    if (drawerItems && typeof drawerItems.onCartUpdate === 'function') return Promise.resolve(drawerItems.onCartUpdate());
    return Promise.resolve();
  }
  function setCode(code) {
    return realFetch(ROOT + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: code })
    }).then(function (r) { return r.json(); });
  }
  function cartAction(btn) {
    if (busy) return;
    busy = true;
    btn.classList.add('is-busy');
    var code = btn.getAttribute('data-code') || '';
    var remove = btn.getAttribute('data-sy-act') === 'remove';
    var before = (cartCache && cartCache.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; })[0] || '';
    setCode(remove ? '' : code).then(function (cart) {
      var ok = remove || (cart.discount_codes || []).some(function (d) { return String(d.code).toUpperCase() === code && d.applicable; });
      if (!ok) {
        flash = code + ' can’t be used on this bag right now.';
        return setCode(before).then(function () { return redrawTheme(); });
      }
      flash = remove ? null : code + ' applied. It carries through to checkout.';
      return redrawTheme();
    }).catch(function () { flash = 'Couldn’t update the code. Please try again.'; })
      .then(function () { busy = false; return refresh(); })
      .then(function () { setTimeout(function () { if (flash) { flash = null; refresh(); } }, 4000); });
  }

  /* refresh after anything changes the cart */
  window.fetch = function (input, init) {
    var u = typeof input === 'string' ? input : (input && input.url) || '';
    var m = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    var res = realFetch(input, init);
    if (m === 'POST' && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(u)) {
      res.then(function () { if (!busy) setTimeout(refresh, 350); }).catch(function () {});
    }
    return res;
  };

  document.addEventListener('toggle', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('sy-cp__list')) window.__syCpOpen = e.target.open;
  }, true);

  function boot() {
    if (!COUPONS.length) return;
    /* keep the panel in place when the theme redraws the drawer */
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var missing = false;
        document.querySelectorAll('.cart__ctas').forEach(function (c) { var p = c.previousElementSibling; if (!p || !p.classList.contains('sy-cp')) missing = true; });
        if (missing && cartCache) paint(cartCache);
        document.querySelectorAll('[data-sy-offers-pdp]').forEach(function (b) { if (!b.__done) pdpRender(b, cartCache); });
        cardsRender(document);
      }, 60);
    }).observe(document.body, { childList: true, subtree: true });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
        var v = ev && ev.data && ev.data.variant;
        if (!v) return;
        document.querySelectorAll('[data-sy-offers-pdp]').forEach(function (b) { b.setAttribute('data-price', v.price); pdpRender(b, cartCache); });
      });
    }
    cardsRender(document);
    document.addEventListener('sy:cards', function (ev) { cardsRender(ev && ev.detail && ev.detail.root); });
    var hasPdp = document.querySelector('[data-sy-offers-pdp]');
    if (hasPdp) pdpAll(null);
    if (COUPONS.length || hasPdp) refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
